import { CancelOutlined } from "@mui/icons-material";
import { Box, Divider, IconButton, Paper } from "@mui/material";
import React from "react";

import { SortableList } from "components/detector/NotesModal/NotesContent/NotesSection/SortableComponents/SortableContainer";
import { Typography } from "new-components/typography/Typography";

export type ChoiceOption = {
  id: string;
  text: string;
};

type MultichoiceOptionsProps = {
  title: string;
  options: ChoiceOption[];
  setOptions: (items: ChoiceOption[]) => void;
};

export default function MultichoiceOptions({ title, options, setOptions }: MultichoiceOptionsProps) {
  return (
    <Box className="mt-4">
      <Typography fontWeight="medium" textTransform="uppercase" className="text-black mb-5">
        {title}
      </Typography>
      <Divider />
      {options && options?.length > 0 && (
        <SortableList
          stackProps={{
            spacing: 0.5,
          }}
          items={options}
          onChange={setOptions}
          renderItem={(item) => (
            <SortableList.Item id={item.id}>
              <MultiChoiceOption
                key={item.id}
                item={item}
                onDelete={(id) => setOptions(options.filter((item) => item.id !== id))}
                DragHandle={SortableList.DragHandle}
              />
            </SortableList.Item>
          )}
        />
      )}
    </Box>
  );
}

type MultichoiceOptionProps = {
  DragHandle: () => React.JSX.Element;
  item: ChoiceOption;
  onDelete: (id: string) => void;
};

function MultiChoiceOption({ DragHandle, item, onDelete }: MultichoiceOptionProps) {
  return (
    <Box display="flex" gap={1} alignItems="center" justifyContent="space-between" className="p-2.5">
      <DragHandle />
      <Paper
        elevation={0}
        className="p-2.5 w-full"
        sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
      >
        {item.text}
        <IconButton size="small" onClick={() => onDelete(item.id)}>
          <CancelOutlined fontSize="inherit" />
        </IconButton>
      </Paper>
    </Box>
  );
}
